import { Component, OnInit} from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { FormGroup, FormBuilder } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef } from '@angular/material/dialog';
import { StatusConstant } from '../status/status-constant';

@Component({
  selector: 'app-addtouchestype',
  templateUrl: './addtouchestype.component.html',
  styleUrls: ['./addtouchestype.component.scss'] 
})

export class AddTouchesTypeComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;    
  formDialog: FormGroup; 
  spinner:boolean=false;
  OfficeIDList: any=[];
  myOfficeID: any;
  activityNameList:any=[]=[];
  activityNameFilterList:any=[]=[];
  selectedtouchTypeID:number=0;
  ShowNoRecordFoundStatus:boolean=false;

  constructor(public dialogRef: MatDialogRef<AddTouchesTypeComponent>,  
    private formBuilder: FormBuilder,private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private coreService: CoreService,private toastr: ToastrService,
    private statusConst: StatusConstant) {   
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    if(encryptedtoken!=null){
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
      this.currentUser = jwt_decode(token); 
      var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
      offices.forEach((oe:any) => {
      this.OfficeIDList.push(oe.officeID);
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
    } 
  }  
  
  ngOnInit(): void {  
    let groupaddtouchtype = {};
    this.formDialog = new FormGroup(groupaddtouchtype);
    this.formDialog.addControl('touchTypeName', this.formBuilder.control(''));  
    this.unMappedTouchesTypes(); 
   }     
       

   unMappedTouchesTypes(){
    let ReqModel = {          
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      userId: this.currentUser?.UID ?? "6f86c326-7418-4bb1-a52c-3649cfb6bcaf",
      officeID:this.myOfficeID
    }   
    this.coreService.unMappedTouchesTypes(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;       
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.activityNameList= this.responseHolder.data;
          this.activityNameFilterList= this.responseHolder.data;
          if(this.activityNameList.length>0){
            this.ShowNoRecordFoundStatus=false;
          }else{
            this.ShowNoRecordFoundStatus=true;
          }
        }
        else{
                    
        }
      }else{
        
      }
    });
   }


  AddTouchTypeName(data:any) {
     let ReqModel = {
      touchTypeName: data.touchTypeName.trim(),      
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      userId: this.currentUser?.UID ?? "6f86c326-7418-4bb1-a52c-3649cfb6bcaf",
      officeID:this.myOfficeID
    }
    this.spinner=true;
    this.formDialog.markAsPristine();
    this.coreService.AddTouchTypeName(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner=false;
        if (this.responseHolder.data == true) {
          this.formDialog.reset();
          this.dialogRef.close('Added');
          this.toastr.success('Note type name added successfully.', '', {
            timeOut: 2000,
          });     
        }else{
          this.spinner=false;
          this.toastr.warning('Already exist.', '', {
            timeOut: 2000,
          });         
        }
      }else{
        this.spinner=false;
      }
    });
  }

   closeAddTouchType() {
    this.formDialog.reset();    
    this.dialogRef.close();
  }

  SelectStatus(data:any){
    this.selectedtouchTypeID = data.touchTypeID;
    this.formDialog.controls['touchTypeName'].setValue(data.touchName);
    this.formDialog.markAsDirty();   
  }

  onSearchChange(searchValue: string): void {   
    if(searchValue==""){
      this.selectedtouchTypeID=0;
      this.unMappedTouchesTypes();     
    }else{
      this.selectedtouchTypeID=0;
      this.activityNameList= this.activityNameFilterList.filter((x:any)=>x.touchName.toLowerCase()==searchValue.toLowerCase());
      if(this.activityNameList.length>0){
        this.ShowNoRecordFoundStatus=false;
      }else{
        this.ShowNoRecordFoundStatus=true;
      }      
    }
  }

}
